import FlexPane from './_flex-pane.js'
import PageHeader from './_page-header.js'
import BannerPromotions from './_banner-promotions.js'

export default {
  name: 'VirtualSportPageView',
  values: {
    hideBreadcrumbs: false,
    _mobile_hideBreadcrumbs: true,
    hideHeader: true,
    _mobile_hideHeader: false,
    hideSportsMenu: false,
    showCompactLayout: false,
    _mobile_showCompactLayout: true,
    documentHeadMetaFactory: undefined,
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        _mobile_itemSpacing: '0px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    menuContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    pageHeader: {
      configSet: PageHeader,
      configValues: {
        icon: {
          src: 'virtuals',
        },
      },
    },
    leftPromotions: {
      configSet: BannerPromotions,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
